<template>
  <div class="arrive-notice-wrap">
    <hot-spot v-if="count === 0" @btnClick="catchSubscribe" />
    <btn-config
      :width="useRedAddCart ? 1.36 : noticeInputBtnWidth"
      :height="useRedAddCart ? 0.64 : 0.52"
      :border-radius="useRedAddCart ? 0.12 : 0.26"
      :has-background="!useIcon || (useIcon && hasSubscribed)"
      :has-bg-img="useIcon && !hasSubscribed"
      :bg-color="useIcon && hasSubscribed ? '#D9D9D9' : '#fff'"
      :border-color="useRedAddCart ? '#F03100' : borderColor"
      has-border
      :font-color="
        useRedAddCart
          ? '#F03100'
          : useIcon
          ? '#fff'
          : hasSubscribed
          ? '#BFBFBF'
          : THEME_COLOR
      "
      :font-weight="'500'"
      :text="noticeText"
      :icon-size="'16px'"
      :icon-name="iconName"
    />
  </div>
</template>
<script>
import HotSpot from './hotSpot'
import BtnConfig from './btnConfig'
import { NEW_ADD_CART_STEP } from '@/defines/const'
import { THEME_COLOR } from '@/defines/environment/config'

export default {
  name: 'ComplexComp',
  components: {
    BtnConfig,
    HotSpot
  },
  props: {
    useRedAddCart: {
      type: Boolean,
      default: false
    },
    hasSubscribed: {
      type: Boolean,
      default: false
    },
    canBuy: {
      type: Boolean,
      default: false
    },
    useIcon: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: 0
    },
    btnWidth: {
      type: Number,
      default: 0.52
    },
    text: {
      type: String,
      default: ''
    },
    addStepType: {
      type: String,
      default: 'normal'
    }
  },
  data() {
    return {
      THEME_COLOR
    }
  },
  computed: {
    noticeInputBtnWidth() {
      const stepType = NEW_ADD_CART_STEP[this.addStepType]
      return this.useIcon ? this.btnWidth : stepType.noticeInputBtnWidth
    },
    noticeText() {
      return this.useIcon ? '' : this.hasSubscribed ? '已订阅' : '到货提醒'
    },
    iconName() {
      return this.useIcon ? 'daohuotixing' : ''
    },
    borderColor() {
      return this.useIcon ? '' : this.hasSubscribed ? '#BFBFBF' : THEME_COLOR
    }
  },
  methods: {
    catchSubscribe() {
      this.$emit('subscribe')
    }
  }
}
</script>
<style lang="scss" scoped>
.arrive-notice-wrap {
  position: relative;

  height: 28px;
  @include flex-row-center;
}
</style>
